import React, { useState } from "react";
import { Input, Slider, Switch } from "./styles";

export default ({ checked = false, color, register, name }) => {
  const [toggle, setToggle] = useState(checked);

  return (
    <Switch>
      <Input {...register(name, { value: checked })} {...{ color: color ? color : '--green' }} type="checkbox" id={name} defaultChecked={toggle} />
      <Slider {...{ toggle, color: color ? color : '--green' }} onClick={() => setToggle(!toggle)} />
    </Switch>
  );
};
